/*
 * @Description:
 * @Autor: lwq
 * @Date: 2020-08-31 11:40:21
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:18:44
 * @FilePath: \mrc-base-frontend\src\directives.js
 */
import ls from '@/utils/Ls';
export default {
  install(Vue) {
    // 自定义按钮指令
    // Vue.directive('btnAuth', {
    //   inserted (el, binding) {
    //     const btnPermission = JSON.parse(ls.get('btnPermission')) || []
    //     let show = false
    //     show = binding.value.some(item => btnPermission.includes(item))

    //     if (show) {
    //       el.style.display = 'block'
    //     } else {
    //       el.style.display = 'none'
    //     }
    //   }
    // })
    Vue.directive("btnAuth", (el, binding) => {
      const btnPermission =
        JSON.parse(ls.get("btnPermission")) || [];
      let show = false;
      show = binding.value.some((item) => btnPermission.includes(item));
      if (show) {
        el.style.display = "inherit";
      } else {
        el.style.display = "none";
      }
    });
  },
};
